import { XdhTreeSelect } from 'components'
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import {loadRegionTree} from '@/utils/tree'
import {getRegionList} from '@/api/get-data.js'

export default {
  name: 'StationOverview',
  data () {
    return {
      // 树数据
      treeData: [],
      // 遮罩层
      loading: false,
      // 表格数据
      tableData: [],
      tableTotalRow: 0,
      // 表格查询条件
      tableQueryParams: {
        parentRegionId: 0,
        orderBy: 0, // 排序方式,0-增序，1-减序
        pageNum: 1,
        pageSize: 15
      },
      // 表格选中记录数组
      tableSelectedIds: [],
      // 表格当前行
      tableCurrentRow: null
    }
  },
  components: {
    XdhTreeSelect
  },
  mixins: [
    ssoLoginMixin,
    convertorMixin,
    idNameMixin
  ],
  mounted () {
    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取区域列表
      this.getRegionList2()
    })
  },
  methods: {
    // 查询区域列表
    getRegionList2() {
      this.loading = true
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.loading = false
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData)
        this.$nextTick(() => {
          if (this.treeData.length) {
            this.tableQueryParams.parentRegionId = this.treeData[0].id
            this.handleTreeNodeClick(this.treeData[0]) // 单击当前节点
          }
        })
      })
    },
    // 查询站点区域列表
    getStationRegionList() {
      this.loading = true
      this.$http(this.$api.regionList, this.tableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.tableData = res.data
            this.tableTotalRow = res.page.totalRow
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 单击树节点
    handleTreeNodeClick(obj) {
      this.tableQueryParams.pageNum = 1
      this.getStationRegionList()
    },
    // 查询按钮操作
    handleFormQuery() {
      this.tableQueryParams.page = 1
      this.getStationRegionList()
    },
    // 重置按钮操作
    resetQueryForm() {
      if (this.treeData.length) {
        this.tableQueryParams.parentRegionId = this.treeData[0].id
      }
      this.tableQueryParams.pageNum = 1
      this.$refs['queryForm'].resetFields()
      this.handleFormQuery()
    },
    // 分页
    handleTableCurrentPageChange(val) {
      this.tableQueryParams.pageNum = val
      this.getStationRegionList()
    },
    // 页面条数改变
    handleTablePageSizeChange(val) {
      this.tableQueryParams.pageSize = val
      this.getStationRegionList()
    },
    // 表格选中记录改变
    handleTableSelectionChange(selection) {
      this.tableSelectedIds = selection.map(item => item.id)
    },
    // 查看事件
    handleTableView(row) {
      if (row && row.id) {
        this.$refs.table.setCurrentRow(row) // 选中当前行
        // this.showTableModalOpen = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/home/stationOverview/StationOverview.js